module.exports = __webpack_public_path__ + "img/coaching.575d7691.svg";